import type { Article } from '../types';

/**
 * Format article date for display
 */
export function formatArticleDate(date: Date, locale: string = 'en-GB'): string {
  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

/**
 * Format article date short for display
 */
export function formatArticleDateShort(date: Date, locale: string = 'en-GB'): string {
  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

/**
 * Check if article is recent (published in last 7 days)
 */
export function isArticleRecent(article: Article): boolean {
  const createdTimestamp = article.created?.timestamp;
  if (!createdTimestamp) return false;

  const articleDate = new Date(createdTimestamp * 1000);
  const now = new Date();
  const diffInMs = now.getTime() - articleDate.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  return diffInDays <= 7;
}

/**
 * Get relative time string (e.g., "3 days ago", "yesterday")
 */
export function getRelativeTimeString(date: Date, locale: string = 'en'): string {
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInDays === 0) return 'Today';
  if (diffInDays === 1) return 'Yesterday';
  if (diffInDays > 0 && diffInDays <= 7) return `${diffInDays} days ago`;
  if (diffInDays < 0 && Math.abs(diffInDays) <= 7) return `In ${Math.abs(diffInDays)} days`;

  return date.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' });
}

